"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { captureFirstTouchIfAbsent } from "@/lib/analytics/firstTouch";

/**
 * Mounts on every first-party page — including the SEO content/marketing
 * pages, which never mint the app's own `plotzio_anon_session` cookie — to
 * capture FIRST-touch UTM/referrer/landing-page attribution once per browser.
 * Skips `/embed` for the same reason posthog-bootstrap.tsx does: embeds
 * render on third-party pages, so there's no "our site" landing to attribute.
 * Renders nothing.
 */
export function FirstTouchCapture() {
  const pathname = usePathname();
  useEffect(() => {
    if (pathname?.startsWith("/embed")) return;
    captureFirstTouchIfAbsent();
  }, [pathname]);
  return null;
}
